<template>
  <DatatableV3
    id="customer-equipment-table"
    ref="datatable"
    :config="config"
    :source="source"
    :map-records="filterParams"
    :flat="!!customerId"
    :hide-header="!!customerId"
    :hide-page-length-select="!!customerId"
    :no-download="!!customerId"
    :auto-height="!customerId"
  />
</template>

<script>
import DatatableV3 from "@/components/DatatableV3.vue";
import { EventBus } from "../lib/event_bus.js";
import store from "../vuex/store";
import EquipmentContextMenu from "./EquipmentContextMenu.vue";

export default {
  components: {
    DatatableV3
  },
  props: {
    showArchived: {
      type: Boolean,
      default: () => true
    },
    source: {
      type: String,
      default: ""
    },
    addressId: {
      type: Number,
      default: null
    },
    customerId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      config: {
        order: this.getOrder(),
        columns: this.getColumns(),
        ...this.getOptions(),
        vueComponents: [
          {
            rootId: "equipment-context-menu-vue",
            component: EquipmentContextMenu,
            options: {
              store,
              listeners: { "save-success": this.refreshData }
            }
          }
        ]
      }
    };
  },
  mounted() {
    EventBus.$on("refresh-customer-equipment-datatable", this.refreshData);
  },
  beforeUnmount() {
    EventBus.$off("refresh-customer-equipment-datatable", this.refreshData);
  },
  methods: {
    filterParams(filters) {
      if (!this.showArchived) {
        filters.archived = false;
      }
      if (this.customerId) {
        filters.customer_id = this.customerId;
      }
      if (this.addressId) {
        filters.address_id = this.addressId;
      }
    },
    getOrder() {
      return [[this.getColumns().length - 3, "asc"]];
    },
    getColumns() {
      const columns = [
        { data: "equipment_name", title: "Equipment Name" },
        { data: "equipment_type", title: "Equipment Type" },
        { data: "oldest_component_date", title: "Oldest Component" },
        { data: "last_service_date", title: "Last Service Date" },
        { data: "warranty_program", title: "Warranty Program" }
      ];
      return columns;
    },
    getOptions() {
      if (this.customerId) {
        return {
          paging: false,
          ordering: false,
          info: false,
          searching: false
        };
      }
      return {};
    },
    refreshData() {
      this.$refs.datatable.refreshData();
    }
  }
};
</script>

<style lang="scss">
.equipment-dt-actions {
  width: 50px;
  padding: 0;
  color: var(--lightblue) !important;
}
table td.equipment-dt-address {
  width: 20%;
  white-space: nowrap;
}
#customer-equipment-table {
  tr > td {
    vertical-align: baseline !important;
  }
}
</style>
